import React from 'react';
import {Card, Typography} from 'antd';
import './ManagementHeader.css';

const { Title, Text } = Typography;

/**
 * 공통 관리 화면 헤더
 * Props:
 *  - icon: ReactNode (아이콘)
 *  - title: string
 *  - actions: ReactNode (우측 액션 영역)
 *  - description?: string (타이틀 하단 설명)
 *  - children?: ReactNode (description 대체 세부 내용 필요 시)
 *  - className?: string
 *  - style?: React.CSSProperties
 */
const ManagementHeader = ({ icon, title, actions, description, children, className = '', style }) => {
  return (
    <Card
      size="small"
      className={`management-header-card ${className}`}
      styles={{ body: { padding: 16 } }}
      style={style}
    >
      <div className="management-header-row">
        <Title level={3} className="management-header-title">
          {icon && <span className="icon-wrapper">{icon}</span>}
          {title}
        </Title>
        <div className="management-header-actions">{actions}</div>
      </div>
      {description && <Text type="secondary" className="management-header-desc">{description}</Text>}
      {children}
    </Card>
  );
};

export default ManagementHeader;
